import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Option } from 'components/atoms/select/types';
import { ProjectOption } from 'components/organisms/timesheets/common/project-option';
import { TitleSelect } from 'components/organisms/timesheets/common/title-select';
import { LinkTrigger } from '../components';

const Select = styled(TitleSelect)`
  margin-bottom: var(--spacing-03);
`;

export const ProjectSelect: FC<{
  options: Option[];
  value: Option;
  onChange: (option: Option) => void;
}> = ({ options, value, onChange }) => {
  return (
    <Select
      options={options}
      selected={value}
      onChange={(selected) => onChange(selected as Option)}
      triggerComponent={LinkTrigger}
      components={{
        Option: ProjectOption,
      }}
      noOptionsMessage={() => (
        <FormattedMessage id="projects.no_results.empty.title" />
      )}
    />
  );
};
